<!--<div id="barrierefreiheitIconContainer" matTooltip="Barrierefreiheit" matTooltipClass="barriereFreiheitTitel">-->
<div id="barrierefreiheitIconContainer" matBadge="-" [matBadgeHidden]="!unterschiede" tabindex="0" class="aLinks" (keydown.enter)="einstellungenOeffnen()">
  <mat-icon (click)="einstellungenOeffnen()">accessibility</mat-icon>
</div>
